export function workspaceDraggedColumnClass(isDragged: boolean): string {
  return isDragged
    ? 'bg-brand/10 shadow-[0_0_0_1px_rgba(37,99,235,0.16)_inset]'
    : '';
}

export function workspaceDropTargetClass(
  isDropTarget: boolean,
  dropPosition: 'before' | 'after' | null
): string {
  if (!isDropTarget || !dropPosition) return '';
  return dropPosition === 'before'
    ? "relative after:pointer-events-none after:absolute after:inset-y-0 after:left-0 after:z-40 after:w-1 after:bg-brand after:content-['']"
    : "relative after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:z-40 after:w-1 after:bg-brand after:content-['']";
}
